<template>
    <div>
        <form method="POST" action="/admin/statistics/unprofitable_products/excel">
            <input type="hidden" name="_token" value="" id="form_token">
            <div class="row">
                <div class="col-md-9">
                    <h3>Выборка даты</h3>
                    <date-range-picker></date-range-picker>
                    <div class="form-group clearfix">
                        <div class="col-md-6">
                            <div class="sales-statistics__search-container">

                                <label>
                                    <input type="radio" name="active_section" v-model="active_section" value="all_products">
                                    Все продукты
                                </label>

                                <label>
                                    <input type="radio" name="active_section" v-model="active_section" value="select_products">
                                    Выбрать продукты
                                </label>

                                <div v-if="active_section === 'select_products'">
                                    <label>Продукты:</label>
                                    <input type="text" v-model="search_string" @keydown.esc="clearAutoCompleteList()" class="form-control">
                                    <input type="hidden" name="product_ids" :value="getActiveProductIds()">

                                    <div class="form-group" v-show="active_products.length" style="margin-top: 15px;">
                                        <b>Выбранные продукты:</b>
                                        <div v-for="(active_product, index) in active_products">
                                            <i class="fa fa-close text-danger" @click="deleteSelectedProduct(index)"></i>
                                            <span v-text="active_product.name"></span>
                                        </div>
                                    </div>

                                    <div class="sales-statistics__autocomplete-result-container" v-show="found_products.length > 0">
                                        <div class="sales-statistics__autocomplete-result__body">
                                            <ul class="list-group">
                                                <li
                                                        v-for="product in found_products"
                                                        class="list-group-item sales-statistics__autocomplete-result-item"
                                                        @click="setActiveProduct(product)"
                                                >
                                                    {{product.name}}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <button type="button" class="btn btn-primary form-control" @click="load">
                            <span v-show="!show_loader">Выгрузить данные</span>
                            <i v-show="show_loader" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        </button>
                    </div>
                    <div class="form-group" v-if="common_data.length">
                        <button type="submit" class="btn btn-success form-control">
                            <i class="fa fa-file-excel-o"></i>
                            Сохранить в Excel
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div v-show="common_data.length">
            <div v-for="data in common_data" style="max-width: 1625px; max-height: 500px; margin-bottom: 50px;">
                <h4 v-text="data.name"></h4>
                <canvas :id="`chart_${data.id}`" width="1625" height="500"></canvas>
            </div>
        </div>
        <table-pagination v-show="common_data.length"
              :display_per_page="false"
        ></table-pagination>
    </div>
</template>

<script>
export default {
    created: function () {
        this.$root.$on('update:page', (val) => { this.page = val});

        this.$root.$on('update:date_range', (val) => {
            this.date_start = val.date_start;
            this.date_finish = val.date_finish;
        });
    },
    mounted: function() {
        Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        document.querySelector('#form_token').value = document.querySelector('#token').getAttribute('content');
    },
    data: function () {
        return {
            // Pagination
            page: 1,
            per_page: 10,

            // Charts
            charts: {},
            date_start: '',
            date_finish: '',
            common_data: [],
            show_loader: false,
            active_section: 'all_products',

            // Auto complete
            search_string: '',
            found_products: [],
            active_products: [],
            auto_complete_cache: {},
        };
    },
    methods: {
        // SETTINGS
        destroyChars: function () {
            for (let i = 0; i < this.charts.length; i++) {
                this.charts[i].destroy();
            }
            this.charts = {};
        },
        initCharts: function () {
            this.destroyChars();

            this.$nextTick(() => {
                for (let i = 0; i < this.common_data.length; i++) {
                    let ctx = document.getElementById(`chart_${this.common_data[i].id}`);

                    this.charts[this.common_data[i].id] = new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: [],
                            datasets: [{
                                label: 'Количество просмотров',
                                data: [],
                                borderColor: 'rgba(255,206,86,1)',
                                backgroundColor: 'rgba(255,206,86,0.2)',
                                fill: false,
                                borderWidth: 1
                            },
                            {
                                label: 'Количество доступных упаковок',
                                data: [],
                                borderColor: 'rgba(255,99,132,1)',
                                backgroundColor: 'rgba(255,99,132,0.2)',
                                fill: false,
                                borderWidth: 1
                            },
                            {
                                label: 'Количество продаж',
                                data: [],
                                borderColor: 'rgba(54,162,235,1)',
                                backgroundColor: 'rgba(54,162,235,0.2)',
                                fill: false,
                                borderWidth: 1
                            }]
                        }
                    });
                }

                this.updateChartData();
            });
        },

        deleteSelectedProduct: function (index) {
            this.active_products.splice(index, 1);
        },

        // AUTO COMPLETE
        autoComplete: function (search_string) {
            if (search_string.length < 3) {
                return;
            }

            if (search_string in this.auto_complete_cache) {
                this.found_products = this.getFromCache(search_string);
                return;
            }

            let self = this;
            this.$http
                .post('/warehouse/inventory/autocomplete', {search_string: search_string})
                .then(function (response) {
                    self.found_products = response.data.products;
                    self.putToCache(search_string, response.data.products);
                });
        },
        setActiveProduct: function (product) {
            this.search_string = '';
            this.active_products.push(product);
            this.clearAutoCompleteList();
        },
        getFromCache: function (key) {
            return this.auto_complete_cache[key];
        },
        putToCache: function (key, search_result) {
            this.auto_complete_cache[key] = search_result;
        },
        clearAutoCompleteList: function () {
            this.found_products = [];
        },

        // LOADING DATA
        checkEnteredData: function () {
            return this.date_start && this.date_finish;
        },
        load: function () {
            if (!this.checkEnteredData()) {
                alert('Заполните обязательные поля!');
                return;
            }
            this.show_loader = true;

            this.$http.post(this.getLoadRoute(), this.getLoadParams()).then(function (response) {
                this.common_data = response.data.stats_data;
                this.$root.$emit('update:table', response.data.table_data);
                this.initCharts();
                this.show_loader = false;
            }, function (response) {
                this.displayErrors(response);
            });
        },
        getLoadRoute: function () {
            if (this.active_section === 'all_products') {
                return '/statistics/unprofitable_products/get_all';
            }

            return '/statistics/unprofitable_products/get_by_product_ids';
        },
        getLoadParams: function () {
            let params = {
                page: this.page,
                per_page: this.per_page,
                date_start: this.date_start,
                date_finish: this.date_finish,
            };

            if (this.active_section === 'select_products') {
                params['product_ids'] = this.getActiveProductIds();
            }

            return params;
        },
        getActiveProductIds: function () {
            let productIds = [];
            for (let i = 0; i < this.active_products.length; i++) {
                productIds.push(this.active_products[i].id);
            }

            return productIds;
        },
        displayErrors: function (response) {
            let errors = '';
            this.show_loader = false;

            for (let field in response.data) {
                errors += response.data[field] + '\r\n';
            }

            alert(errors);
        },

        // CHART DATA
        updateChartData: function () {
            for (let i = 0; i < this.common_data.length; i++) {
                let data = this.getChartData(this.common_data[i].dots);
                let id = this.common_data[i].id;
                this.charts[id].data.labels = data.dates;
                this.charts[id].data.datasets[0].data = data.views_quantity;
                this.charts[id].data.datasets[1].data = data.available_quantity;
                this.charts[id].data.datasets[2].data = data.sold_quantity;

                this.charts[id].update();
            }
        },
        getChartData: function (data) {
            let preparedData = {
                dates: [],
                sold_quantity: [],
                views_quantity: [],
                available_quantity: [],
            };

            for (let i = 0; i < data.length; i++) {
                preparedData.dates.push(data[i]['date']);
                preparedData.sold_quantity.push(data[i]['sold_quantity']);
                preparedData.views_quantity.push(data[i]['views_quantity']);
                preparedData.available_quantity.push(data[i]['available_quantity']);
            }

            return preparedData;
        },
    },
    watch: {
        'search_string': function (val) {
            this.autoComplete(val);
        },
        'page': function () {
            this.load();
        },
        'active_section': function () {
            this.page = 1;
        },
    },
};
</script>
